/**
 * Stop-Go lamp - one chamber for stop signal with cross
 * - used in Charleroi
 * - needs to be adjusted for different cities when needed
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

import Konva from 'konva'

export default class ChaSgStopCross extends Element {
  setDefaultShapes () {
    const stopCross = new Konva.Group({
      name: 'stopCross',
      x: 0,
      y: 0,
      visible: false
    })

    const whiteFirstLine = new Ren.Line({
      points: [5, 5, 25, 25],
      stroke: 'white',
      strokeEnabled: true,
      strokeWidth: 2
    })

    const whiteSecondLine = new Ren.Line({
      points: [25, 5, 5, 25],
      stroke: 'white',
      strokeEnabled: true,
      strokeWidth: 2
    })
    stopCross.add(whiteFirstLine)
    stopCross.add(whiteSecondLine)

    this.shapes.push(
      new Ren.Rect({
        name: 'sg',
        x: 0,
        y: 0,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 15,
        radius: 15,
        fill: Color.offlineGray
      }),

      stopCross,

      // signalling foor
      new Ren.Line({
        points: [15, 30, 15, 50],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 50, 30, 50],
        strokeWidth: 2,
        opacity: 0.8
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    // on STOP signal activate red cross
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)

    if (status.signalStop === 1) {
      this.modifyShape('stopCross', 'visible', true)
    } else {
      this.modifyShape('stopCross', 'visible', false)
    }
  }
}
